import { useCallback, useState } from "react";

import SortableListDroppableZone from "./SortableListDroppableZone";
import SortableListOptionsListModal from "./SortableListOptionsListModal";
import Button from "../../Buttons/Button";
import { defineMessages } from "react-intl";
import { useFormatMessage } from "../../Intl/Context";
import { useSortableListInputContext } from ".";

const SortableListTouchScreenInterface = () => {
  const t = useFormatMessage();
  const selectOptions = t(intlMessages.selectOptions);
  const selectOptionsDescription = t(intlMessages.selectOptionsDescription);
  const sortSelectedItemsDescription = t(intlMessages.sortSelectedItemsDescription);

  const { selectedItems } = useSortableListInputContext();
  const hasSelectedItems = selectedItems.length > 0;

  const [isModalShown, setModalShown] = useState(false);

  const showModal = useCallback(() => setModalShown(true), []);
  const hideModal = useCallback(() => setModalShown(false), []);

  return (
    <div className="sortable-list-input">
      <div className="margin-bottom-xs padding-top-xs border-top border-gray">
        <p className="form-text margin-bottom-xs">{selectOptionsDescription}</p>

        <Button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={showModal}
          label={selectOptions}
        />

        {isModalShown && <SortableListOptionsListModal hideModal={hideModal} />}
      </div>

      {hasSelectedItems && (
        <div className="padding-top-xs border-top border-gray">
          <p className="form-text margin-bottom-xs">{sortSelectedItemsDescription}</p>

          <SortableListDroppableZone />
        </div>
      )}
    </div>
  );
};

export default SortableListTouchScreenInterface;

const intlMessages = defineMessages({
  selectOptions: {
    id: "inputs.sortableList.touchScreenUI.selectOptions",
    defaultMessage: "Sélectionner les options"
  },
  selectOptionsDescription: {
    id: "inputs.sortableList.touchScreenUI.selectOptionsDescription",
    defaultMessage: `
      Étape 1 / 2 : Sélectionnez les options que vous souhaitez prioriser en cliquant sur le 
      bouton ci-dessous.
    `
  },
  sortSelectedItemsDescription: {
    id: "inputs.sortableList.touchScreenUI.sortSelectedItemsDescription",
    defaultMessage: `
      Étape 2 / 2 : Priorisez les options sélectionnées à l'aide de la liste ci-dessous en 
      glissant les options entre-elles.
    `
  }
});
